import React from "react";
import "./AboutDetails.css";
import Department from "./Department";

function AboutDetails() {
  return (
    <div className="aboutdetails">
      <div className="detail__text">
        <h2>ABOUT GCE</h2>
        <div className="detail__border">
          <span></span>
        </div>

        <p>
          G B Pant Engineering College was established by the Govt. of NCT of
          Delhi in the year 2007 with the aim of imparting quality technical
          education for the students of Delhi and nearby areas. Since its
          inception, the faculty and staff have been tirelessly working towards
          the growth of the institution. Affiliated to Guru Gobind Singh
          Indraprastha University and approved by AICTE, the college started
          with two batches of students, one each for Mechanical Engineering and
          Electronics and Communications Engineering courses. Increasing its
          horizon in the year 2010, a batch of Computer Engineering course was
          started in the college. With the presence of vibrant and dynamic
          faculty members of highest academic calibre selected by UPSC, G B Pant
          has been able to produce three batches of engineering graduates who
          have been pursuing their careers in companies and higher education
          institutes in India and abroad. The college has been operating from
          its building in G B Pant Polytechnic campus which has been transformed
          to be equipped with ultra-modern facilities. The college has already
          established various labs for all the branches with up to date modern
          equipment which ensures that the students are trained in the practical
          realm according to the current industry standards. The college is in
          the process of making its own building with state of the art
          facilities.
        </p>
      </div>
      <div className="detail__text">
        <h2>OUR VISION</h2>
        <div className="detail__border">
          <span></span>
        </div>

        <p>
          The vision of G B Pant engineering college is to produce a society
          grounded in technological advancement, social justice and equality by
          combining knowledge, creativity, ethics and co-operation.
        </p>
      </div>
      <div className="detail__text">
        <h2>OUR MISSION</h2>
        <div className="detail__border">
          <span></span>
        </div>

        <p>
          The mission of G B Pant govt. engineering college is the advancement
          of knowledge by educating students in Engineering Sciences, Applied
          Sciences and Humanities. By following a holistic and
          inter-disciplinary approach, we believe in producing Engineers who
          would serve the country and the world in the 21st century. The eminent
          faculty of the institute is committed in generating knowledge and
          disseminating it to the students, thereby nurturing them to become
          torch bearers of knowledge. By combining academic rigour and
          excitement of discovery in the subject, the faculty is committed to
          producing students who would become embodiments of intelligence of
          both theory and practice. The college is committed to the overall
          development of the students, making them fine citizens dedicated to
          the betterment of the society.
        </p>
      </div>
      <div className="detail__text">
        <h2>OUR OBJECTIVE</h2>
        <div className="detail__border">
          <span></span>
        </div>

        <p>
          To develop analytical skills and problem solving capabilities in the
          students by educating them in appropriate streams of technology and
          computational methodologies To develop an interdisciplinary
          perspective - and - train the students to work with people belonging
          to different social, cultural, regional and national backgrounds. To
          develop inter-personal, technical and soft skills in the students and
          - train them for decision making in real life engineering, managerial
          and human resource related problems. To inculcate - professional
          ethics and a sense of responsibility towards physical, social,
          economic, political and cultural environment. To inculcate the habit
          and an attitude for life long learning in our students.
        </p>
      </div>
      <div className="about__dep">
        <Department />
        <Department />
        <Department />
        <Department />
      </div>
    </div>
  );
}

export default AboutDetails;
